import type { FC } from "react";

import classNames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";
import { PointsBlock, useTranslations } from "@jti/ui";

import { useCartMiniContext } from "@checkout/contexts/CartMiniContext";

import styles from "./CartMiniPointsBlock.module.scss";

type CartMiniPointsBlockProps = {
  totalPoints: number;
  pending: boolean;
  isActive: boolean;
  className?: string;
};

export const CartMiniPointsBlock: FC<CartMiniPointsBlockProps> = ({
  totalPoints,
  isActive = false,
  pending = false,
  className,
}) => {
  const { __ } = useTranslations();
  const config = useConfig();
  const { isDarkTheme } = useCartMiniContext();

  if (totalPoints === 0 || pending || !isActive) {
    return null;
  }

  const wrapperClasses = classNames(styles.pointsBlockWrapper, className, {
    [styles.dark]: isDarkTheme,
  });

  return (
    <div className={wrapperClasses}>
      <PointsBlock
        hasLogo={true}
        knowMoreUrl={config.LOYALTY_KNOW_MORE_URL}
        urlText={__("cart.ploom_club.pointsBlock.link")}
        points={totalPoints}
        pointsLabel={__("cart.ploom_club.points")}
        text={__("cart.ploom_club.pointsBlock.message", [totalPoints])}
      />
    </div>
  );
};
